import SArray, { SArray as ArraySignal, SDataArray } from 's-array';

export interface NonuniqueIndex<T> {
    (id : id) : ArraySignal<T>;
    (id : () => id) : () => T[];
}

type id = string | number;

export default function nonuniqueIndex<T>(array : ArraySignal<T>, keyFn: (v : T) => id) : NonuniqueIndex<T> {
    const index = {} as { [id : string ] : SDataArray<T> },
        map = array.map<SDataArray<T>>(
            function (item, _s) {
                var key = keyFn(item),
                    s = slot(key);
                if (s !== _s) {
                    if (_s) _s.remove(item);
                    s.push(item);
                }
                return s;
            },
            function (item, s) {
                s.remove(item);
            }
        );

    return indexRef;
    
    function indexRef(id : () => id) : () => T[];
    function indexRef(id : id) : ArraySignal<T>;
    function indexRef(id : id | (() => id)) {
        return typeof id === 'function'
            ? function () { return slot(id())(); }
            : slot(id);
    }

    function slot(id : id) : SDataArray<T> {
        return id in index ? index[id] : index[id] = SArray([]);
    }
}


// WEBPACK FOOTER //
// ./lib/nonuniqueIndex.ts